export const POINT_CHANGE_HISTORY_CREATE_ACTION = "POINT_CHANGE_HISTORY_CREATE_ACTION";
export const POINT_CHANGE_HISTORY_LIST_ACTION = "POINT_CHANGE_HISTORY_LIST_ACTION";
export const POINT_CHANGE_HISTORY_LIST_SUCCESS = "POINT_CHANGE_HISTORY_LIST_SUCCESS";
export const POINT_CHANGE_HISTORY_GET_UPDATE_ACTION = "POINT_CHANGE_HISTORY_GET_UPDATE_ACTION";
export const POINT_CHANGE_HISTORY_GET_UPDATE_SUCCESS = "POINT_CHANGE_HISTORY_GET_UPDATE_SUCCESS";
export const POINT_CHANGE_HISTORY_DELETE_ACTION = "POINT_CHANGE_HISTORY_DELETE_ACTION";
export const POINT_CHANGE_HISTORY_UPDATE_ACTION = "POINT_CHANGE_HISTORY_UPDATE_ACTION";

export const POINT_CHANGE_HISTORY_GET_LIST_ACTION = "POINT_CHANGE_HISTORY_GET_LIST_ACTION";
export const POINT_CHANGE_HISTORY_GET_LIST_SUCCESS = "POINT_CHANGE_HISTORY_GET_LIST_SUCCESS";
export const POINT_CHANGE_HISTORY_GET_LIST_FAIL = "POINT_CHANGE_HISTORY_GET_LIST_FAIL";
export const POINT_CHANGE_HISTORY_DETAIL_ACTION = "POINT_CHANGE_HISTORY_DETAIL_ACTION";
export const POINT_CHANGE_HISTORY_DETAIL_SUCCESS = "POINT_CHANGE_HISTORY_DETAIL_SUCCESS";
export const POINT_CHANGE_HISTORY_DETAIL_FAIL = "POINT_CHANGE_HISTORY_DETAIL_FAIL";
export const POINT_CHANGE_HISTORY_DETAIL_UPDATE_ACTION = "POINT_CHANGE_HISTORY_DETAIL_UPDATE_ACTION";
export const POINT_CHANGE_HISTORY_DETAIL_CREATE_ACTION = "POINT_CHANGE_HISTORY_DETAIL_CREATE_ACTION";
export const POINT_CHANGE_HISTORY_DETAIL_DELETE_ACTION = "POINT_CHANGE_HISTORY_DETAIL_DELETE_ACTION";
